function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35 70C54.33 70 70 54.33 70 35C70 15.67 54.33 0 35 0C15.67 0 0 15.67 0 35C0 54.33 15.67 70 35 70Z",
  fill: "#FF5000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M33.1953 22.5478L20.0453 44.1854L25.2752 41.1659C25.2876 41.1442 25.3004 41.1225 25.3136 41.101L33.1953 28.2686V22.5478ZM47.9508 47.1677H22.536L27.2721 44.4334H43.0365C43.0931 44.4334 43.149 44.4313 43.2041 44.4273L47.9508 47.1677ZM50.0215 43.943L37.0234 22.5553V28.2761L44.7914 40.9234L50.0215 43.943ZM36.9765 15.107C36.1244 13.7051 34.0897 13.7051 33.2377 15.107L13.4466 47.6723C12.5606 49.1301 13.61 50.9959 15.3159 50.9959H54.898C56.6043 50.9959 57.6537 49.1301 56.7678 47.6723L36.9765 15.107ZM35.1071 32.4704L30.1107 40.6052H40.1035L35.1071 32.4704Z",
  fill: "white"
});

var SvgBat = function SvgBat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bat.6a99ef4e.svg";
export { ForwardRef as ReactComponent };